import React, { useEffect } from "react";

import styles from "../../TalentApplication/application.module.css";
import BlackDotsSpinner from "../../../assets/Spinner/BlackDotsSpinner";
import {useAuth0} from "@auth0/auth0-react";

const SessionTransfer = () => {
    const { loginWithRedirect } = useAuth0();

    const loginWithSessionTransferToken = async (session_transfer_token) => {
        await loginWithRedirect({
            authorizationParams: {
                session_transfer_token,
                redirect_uri: process.env.REACT_APP_SHOP_SELLER_DASHBOARD_URL,
                response_type: "code"
            }
        });
    };

    useEffect(() => {
        const urlParameters = new URLSearchParams(window.location.search);
        loginWithSessionTransferToken(urlParameters.get("token"))
    }, [])


    return (
        <div className={`w-full h-full bg-white ${styles.loading}`}>
            <BlackDotsSpinner />
        </div>
    );
}

export default SessionTransfer;